interface subscription {
  id: number;
  title: string;
}

interface TrialOffer {
  id: number;
  language: string;
  amount: string;
  duration: string;
}

export const subscriptionOffers: subscription[] = [
  {
    id: 1,
    title: "Unlock All Interactive Activity Content",
  },
  {
    id: 2,
    title: "Learn Up To 12 African Language",
  },
  {
    id: 3,
    title: "No Ads",
  },
  {
    id: 4,
    title: "Practice With Native Speakers",
  },
];

export const trialOffer: TrialOffer[] = [
  {
    id: 1,
    language: "Igbo",
    amount: "5.00",
    duration: "30",
  },
  {
    id: 2,
    language: "Igbo",
    amount: "5.00",
    duration: "30",
  },
  {
    id: 3,
    language: "Igbo",
    amount: "5.00",
    duration: "30",
  },
  {
    id: 4,
    language: "Igbo",
    amount: "5.00",
    duration: "30",
  },
];
